import Generic from './components/generic/Generic';
import Layout from './components/Layout';
import Loader from 'apollo-react/components/Loader';
import { Suspense } from 'react';

import { PostmongerProvider } from './contexts/PostmongerContext';

import './custom.css'

const App = () => {
    return (
        <Suspense fallback={<Loader />}>
            <PostmongerProvider>
                <Layout>
                    <Generic />
                </Layout>
            </PostmongerProvider> 
        </Suspense>
    );
}

export default App;